import { toBase64 } from "../../lib/common";
import { SERVER_API } from "../../Constant";
import axios from "axios";

export const ImageProcessing = async (file: any, type: any) => {
  try {
    const fileType = file.type;
    const base64 = await toBase64(file);

    const payload = {
      fileType: fileType,
      base64: base64.split(",")[1],
      type,
    };

    const response = await axios.post(
      `${SERVER_API}/ImageProccessing/ImageProccessing.php`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data;
    const candidates = data?.result?.candidates;

    if (!candidates || candidates.length === 0) {
      throw new Error("No data extracted from image");
    }

    return data;
  } catch (error: any) {
    console.error("Image processing failed:", error);
    return { error: error.message || "Image processing failed" };
  }
};
